(function() {

    const WebFont = require('webfontloader');

    WebFont.load({

        google: {
            families: ['Inter:400:latin-ext']
        }
    });
})();

